import { render, staticRenderFns } from "./ProcessCard.vue?vue&type=template&id=7631a9ac&scoped=true"
import script from "./ProcessCard.vue?vue&type=script&lang=js"
export * from "./ProcessCard.vue?vue&type=script&lang=js"
import style0 from "./ProcessCard.vue?vue&type=style&index=0&id=7631a9ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7631a9ac",
  null
  
)

export default component.exports